module.exports = __webpack_public_path__ + "img/plm2.64fb8119.jpg";